<div class="d-flex flex-column gap-4" style="padding: 5%;">
  <div class="text-end">
    <img src="assets/svg/icon-close-dialog.svg" class="pointer" (click)="closeDialog()" alt="icon-alert.svg">
  </div>
  <div class="text-center">
    <img src="assets/svg/icon-check-alert.svg" alt="icon-alert.svg">
  </div>
  <div class="text-center">
    <span class="fs-4 fw-bold text-blue">{{ data?.title }}</span>
  </div>
  <div class="container-text">
    <span class="fs-6 fw-medium text-blue">{{ data?.text }}</span>
  </div>
  <br>
  <button nz-button nzType="primary" class="bg-blue text-white rounded-pill border-0 fs-6" (click)="closeDialog()">{{ data?.textButton }}</button>
</div>